import { isDevMode } from "@angular/core";

export const DEBUG_MODE: boolean = false; // isDevMode();
